import { render, staticRenderFns } from "./PublicKnowledgeMenuItem.vue?vue&type=template&id=cf79c1e4&scoped=true&"
import script from "./PublicKnowledgeMenuItem.vue?vue&type=script&lang=js&"
export * from "./PublicKnowledgeMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./PublicKnowledgeMenuItem.vue?vue&type=style&index=0&id=cf79c1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf79c1e4",
  null
  
)

export default component.exports